import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

type Props = {
  drama: Drama;
  rank?: number;
};

export default function DramaCard({ drama, rank }: Props) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      data-product-shop
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-all hover:-translate-y-1 duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={drama.cover}
          alt={`${drama.title} 海报`}
          title={`${drama.title} 剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 text-[11px] rounded-md bg-primary-950/80 text-background-50">
          {drama.type}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 text-[11px] rounded-md bg-accent-500 text-primary-950 font-medium">
          {drama.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute bottom-2 left-2 w-7 h-7 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center text-sm font-bold">
            {rank}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-primary-950/90 to-transparent" />
        <span className="absolute bottom-2 right-2 text-[11px] text-background-100">
          {drama.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 line-clamp-1">
          {drama.cast.slice(0, 3).join(" / ")}
        </p>
        <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500">
          <span className="flex items-center gap-1 flex-wrap">
            <i className="ri-map-pin-line" aria-hidden="true"></i>
            {drama.region}
            <span className="text-background-400">·</span>
            {drama.year}
          </span>
        </div>
      </div>
    </Link>
  );
}